export const APPOINTMENT_TYPES = ["measurement", "placement", "shipment"];

export const isValidType = (type: string): boolean => {
  return APPOINTMENT_TYPES.includes(type);
};
